import { Heading, HStack, Skeleton, Stack } from "@chakra-ui/react";
import { useQuery } from "@apollo/client";
import { QuickActionCard } from "src/components/QuickActionCard";
import { GET_MY_PORTFOLIO_DASHBOARD_COMPLETION } from "src/common/graphql/typed-queries";
import { LaborPassCompletionCard } from "src/features/pro-portfolio/laborpass-completion-card";
import {
	getLaborPassCompletionState,
	getPublicLaborPassUrl,
} from "src/features/pro-portfolio/laborpass-helpers";

export const NewDashboard = () => {
	const { data, loading } = useQuery(GET_MY_PORTFOLIO_DASHBOARD_COMPLETION, {
		fetchPolicy: "cache-and-network",
	});

	const completionState = getLaborPassCompletionState(data?.myPortfolio);
	const publicUrl = data?.myPortfolio?.handle
		? getPublicLaborPassUrl(data.myPortfolio.handle)
		: null;

	return (
		<div className="flex flex-col gap-8 w-full bg-[#FEFEFE]">
			{loading && !data ? (
				<Stack spacing={4}>
					<Skeleton height="40px" />
					<Skeleton height="420px" />
				</Stack>
			) : null}
			{completionState !== "incomplete" && publicUrl ? (
				<LaborPassCompletionCard
					completionState={completionState}
					publicUrl={publicUrl}
				/>
			) : null}
			<Stack>
				<HStack
					borderBottom={"1px"}
					borderColor={"#E4E4E4"}
					py={4}
					textColor={"#212121"}
					mb={{
						base: 4,
						lg: 8,
					}}
				>
					<Heading
						as={"h2"}
						fontWeight={"normal"}
						fontSize={{
							base: "18px",
							lg: "20px",
						}}
					>
						Quick action
					</Heading>
				</HStack>
				<Stack
					direction={{
						base: "column",
						lg: "row",
					}}
					gap={{
						base: 4,
						lg: 8,
					}}
				>
					<QuickActionCard
						cta="Go to my LaborPass portfolio"
						ctaLink={`/my-laborpass`}
						description="Work on your LaborPass portfolio to showcase your skills and experience."
						title="Update your LaborPass portfolio"
					/>
					{/* <QuickActionCard
						cta="Chat with Aina"
						ctaLink={`${process.env.REACT_APP_ARTISAN_ASSISTANT_WHATSAPP_BOT}`}
						description="Easily create and send professional invoices to your clients through WhatsApp. Save time and get paid faster."
						title="Streamline Your Invoicing"
					/> */}
					{/* <QuickActionCard
						cta="Get a certification"
						ctaLink="/certificates"
						description="Become a verified LaborHack Pro by earning certifications and showcasing your expertise."
						title="Upgrade Your Skills"
					/> */}
				</Stack>
			</Stack>
		</div>
	);
};
